import 'core-js/stable';
import './scss/index.scss';
import FinanceApplication from './finance-application';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.finance-application-spa').forEach((el) => (el.classList.contains('load') ? new FinanceApplication(el) : null));
});
